import { MutationTree } from "vuex";
import * as types from "./types";

export default <MutationTree<survey.state.SurveyState>>{
    [types.SURVEY_LIST](state, payload: survey.SurveyListResponse) {
        state.listGrid = payload;
    },

    [types.SURVEY_PAGESET](state, payload: survey.SurveyListRequest) {
        state.pageSet = payload;
    },

    [types.SURVEY_LIST_TOTALCOUNT](state, payload: number) {
        state.listTotalCount = payload;
    },

    [types.SURVEY_CREATED_SURVEYID](state, payload?: number) {
        if (payload == null) {
            state.createdSurveyId = Object.create(null);
        } else {
            state.createdSurveyId = payload;
        }
    },

    [types.SURVEY_INIT_QUESTION](state, payload: Array<survey.SurveyQuestionDetail>) {
        state.createdQuestions = payload;
    },

    //질문생성
    [types.SURVEY_ADD_QUESTION](state, payload: survey.SurveyQuestionItem) {
        let pushItem = {
            questionInfo: payload,
            examples: [],
        } as survey.SurveyQuestionDetail;

        state.createdQuestions.push(pushItem);
    },

    //질문수정
    [types.SURVEY_UPDATE_QUESTION](state, payload: survey.SurveyQuestionItem) {
        //보류
        let questions = state.createdQuestions;

        questions.map((obj) => {
            if (obj.questionInfo.surveyQuestionId == payload.surveyQuestionId) {
                obj.questionInfo.questionOrders = payload.questionOrders;
                obj.questionInfo.questionType = payload.questionType;
                obj.questionInfo.isAdditionalOption = payload.isAdditionalOption;
                obj.questionInfo.questionText = payload.questionText;
            }
        });
    },

    //보가생성
    [types.SURVEY_ADD_EXAMPLE](state, payload: survey.SurveyExampleItem) {
        state.createdQuestions.forEach((item) => {
            if (item.questionInfo.surveyQuestionId == payload.surveyQuestionId) {
                item.examples.push(payload);
                return;
            }
        });
    },

    //보기수정
    [types.SURVEY_UPDATE_EXAMPLE](state, payload: survey.SurveyExampleItem) {
        state.createdQuestions.forEach((item) => {
            if (item.questionInfo.surveyQuestionId == payload.surveyQuestionId) {
                item.examples.map((e) => {
                    if (e.surveyExampleId == payload.surveyExampleId) {
                        e.exampleText = payload.exampleText;
                        e.exampleOrders = payload.exampleOrders;
                        e.fileCode = payload.fileCode;
                    }
                });
                return;
            }
        });
    },

    //보기삭제
    [types.SURVEY_DELETE_EXAMPLE](state, payload: survey.SurveyExampleItem) {
        state.createdQuestions.forEach((item) => {
            if (item.questionInfo.surveyQuestionId == payload.surveyQuestionId) {
                item.examples = item.examples.filter((ex) => ex.surveyExampleId != payload.surveyExampleId);
                return;
            }
        });
    },

    [types.SURVEY_ANSWER](state, payload: survey.SurveyAnswerItem) {
        if (payload.questionType === 0 || payload.questionType === 2) {
            state.answers = state.answers.filter((item) => {
                return item.surveyQuestionId != payload.surveyQuestionId;
            });

            state.answers.push(payload);
        } else if (payload.questionType === 1) {
            if (payload.isAdditionalAnswer == true) {
                //제거 대상은 해당 질문에 기타 답변만
                state.answers = state.answers.filter((item) => {
                    return !(item.surveyQuestionId == payload.surveyQuestionId && item.isAdditionalAnswer == true);
                });
            }

            state.answers.push(payload);
        } else if (payload.questionType === 3) {
            let foundIdx = payload.isAdditionalAnswer
                ? state.answers.findIndex((a) => a.surveyQuestionId === payload.surveyQuestionId && a.isAdditionalAnswer)
                : state.answers.findIndex((a) => a.surveyQuestionId === payload.surveyQuestionId && a.surveyExampleId === payload.surveyExampleId);

            if (foundIdx >= 0) {
                state.answers.splice(foundIdx, 1);
            }

            state.answers.push(payload);
        } else {
            //초기 Load
            state.answers.push(payload);
        }
    },

    [types.SURVEY_DELETE_ALL_ANSWER](state, payload?: any) {
        state.answers = [];
    },

    [types.SURVEY_DELETE_ANSWER](state, payload: any) {
        if (payload.isAdditionalAnswer) {
            let idx = state.answers.findIndex((a) => a.surveyQuestionId === payload.questionId && a.isAdditionalAnswer);

            if (idx >= 0) {
                state.answers.splice(idx, 1);
            }
        } else {
            let idx = state.answers.findIndex((a) => a.surveyQuestionId === payload.questionId && a.surveyExampleId === payload.answers);

            if (idx >= 0) {
                state.answers.splice(idx, 1);
            }
        }
    },

    [types.SURVEY_STATISTICS](state, payload: survey.SurveyDetailResponse) {
        state.statisticsDetail = payload;
    },

    [types.SURVEY_RESORTING_QUESTION](state, payload?: any) {
        state.createdQuestions.sort((a, b): any => {
            if (a.questionInfo.questionOrders > b.questionInfo.questionOrders) return 1;
            if (a.questionInfo.questionOrders < b.questionInfo.questionOrders) return -1;
            return 0;
        });
    },

    //payload : questionId
    [types.SURVEY_RESORTING_EXAMPLE](state, payload: number) {
        let targetQuestion = state.createdQuestions.filter((item) => {
            return item.questionInfo.surveyQuestionId == payload;
        });

        if (targetQuestion.length > 0) {
            targetQuestion[0].examples.sort((a, b): any => {
                if (a.exampleOrders > b.exampleOrders) return 1;
                if (a.exampleOrders < b.exampleOrders) return -1;
                return 0;
            });
        }
    },

    [types.SURVEY_ADD_MENU_PERMISSIONS](state, payload: survey.MenuPermissions) {
        //추가면 Array Push
        state.permissions = payload;
    },

    // [types.SURVEY_UPDATE_MENU_PERMISSIONS](state, payload: survey.MenuPermissions) {
    //     //우선 삭제하고
    //     state.permissions = state.permissions.filter(item =>{
    //         return item.MenuId == payload.MenuId
    //     })

    //     state.permissions.push(payload)
    // },
};
